// function getGradientColor(value) {
//     if (!value) {
//         return "#ffffff";
//     }
//     if (value < 40 || value > 100) {
//         return "#ffffff";
//     }

//     let r, g, b;

//     if (value <= 50) {
//         const t = value / 50;
//         r = 255;
//         g = 255;
//         b = Math.round(255 * (1 - t));
//     } else {
//         const t = (value - 50) / 50;
//         r = 255;
//         g = Math.round(255 * (1 - t));
//         b = 0;
//     }

//     const toHex = (n) => n.toString(16).padStart(2, '0');
//     return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
// }
function getGradientColor(value) {
    if (!value || value < 40 || value > 100) {
      return "#ffffff";
    }
  
    // Clamp the value between 50 and 90
    const minVal = 50;
    const maxVal = 90;
    const clamp = Math.max(minVal, Math.min(value, maxVal));
    const t = (clamp - minVal) / (maxVal - minVal); // interpolation factor
  
    // Orange (50) → Red (90)
    const startColor = { r: 237, g: 121, b: 5 };   // #ed7905
    const endColor = { r: 237, g: 5, b: 5 };       // #ed0505
  
    const r = Math.round(startColor.r + (endColor.r - startColor.r) * t);
    const g = Math.round(startColor.g + (endColor.g - startColor.g) * t);
    const b = Math.round(startColor.b + (endColor.b - startColor.b) * t);
  
    const toHex = (n) => n.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

export default getGradientColor;